module.exports = __webpack_public_path__ + "img/geo.1e31f8c8.svg";